import React from 'react';

import lang from '../../../../lib/language';
import { navigationButtonTextLong, navigationButtonTextShort, navigationButtonTextTotal } from '../../../../lib/util/my-account-helpers';

import { ClickableDiv } from '../../../../components/index';

import styles from './NavigationButtons.module.scss';

type Props = {
    activeTab: string;
    handleClick: (value: string) => void;
    isMyAccount?: boolean;
    hasLongs?: boolean;
    hasShorts?: boolean;
}

const NavigationButtons = ({ activeTab, handleClick, isMyAccount, hasLongs, hasShorts }: Props) => {
  const setActiveTabStyle = (currentTab: string) => {
    if (isMyAccount && currentTab === lang.commonAccountBreakdownLong() && !hasLongs) {
      return styles.disabledTab;
    }
    if (isMyAccount && currentTab === lang.commonShort2() && !hasShorts) {
      return styles.disabledTab;
    }
    if (currentTab === activeTab) {
      return styles.activeTab;
    }

    return styles.tab;
  };

  return (
    <div className={styles.buttonsWrapper}>
      <ClickableDiv
        className={setActiveTabStyle(navigationButtonTextTotal)}
        onClick={() => handleClick(lang.commonAccountBreakdownTotal())}
      >
        {lang.commonAccountBreakdownTotal()}
      </ClickableDiv>
      <ClickableDiv
        className={setActiveTabStyle(navigationButtonTextLong)}
        onClick={() => isMyAccount // eslint-disable-line no-confusing-arrow
          ? hasLongs && handleClick(lang.commonAccountBreakdownLong())
          : handleClick(lang.commonAccountBreakdownLong())}
      >
        {lang.commonAccountBreakdownLong()}
      </ClickableDiv>
      <ClickableDiv
        className={setActiveTabStyle(navigationButtonTextShort)}
        onClick={() => isMyAccount // eslint-disable-line no-confusing-arrow
          ? hasShorts && handleClick(lang.commonShort2())
          : handleClick(lang.commonShort2())}
      >
        {lang.commonShort2()}
      </ClickableDiv>
    </div>
  );
};

export default NavigationButtons;
